import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthQueryParamKey } from '../enums/auth-query-param-key';
import { AuthRoute } from '../enums/auth-route';
import { AuthRouterStateKey } from '../enums/auth-router-state-key';

export const resetPasswordGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);

  if (route.queryParamMap.get(AuthQueryParamKey.TOKEN)) return true;

  router.navigateByUrl(AuthRoute.LOGIN, {
    state: { [AuthRouterStateKey.IS_INVALID_RESET_TOKEN]: true },
  });
  return false;
};
